<template>
  <div class="section-main__warp building-analysis">
    <div class="building-search">
      <div class="tabBar">
        <div v-for="(item, index) in tabBar" :key="index" :class="['barItem', activeIndex === index? 'active': '']"
             @click="handleChooseActiveItem(index)">{{item}}
        </div>
      </div>
      <el-date-picker
        v-model="analysisTime"
        type="month"
        value-format="yyyy-MM"
        @change="getList"
        placeholder="选择月">
      </el-date-picker>
    </div>
    <el-scrollbar style="flex: 1" v-if="tableData.length > 0">
      <div class="card-list">
        <div class="card" v-for="(item, index) in tableData" :key="index" @click="handleChooseItem(item)">
          <div class="card-line" :style="{background: hasStatusColor(item.colorType)}"></div>
          <div class="card-index">{{hasIndex(index)}}</div>
          <div class="card-contain">
            <label class="card-contain-title">{{item.buildingName}}</label>
            <div class="card-contain-num">
              <label class="num-label">巡检数量</label>
              <div class="num-percentage">{{item.completeNum}}/{{item.totalNum}}</div>
              <el-progress :percentage="Math.round(item.completeNum/item.totalNum*100)" color="#00A897" :stroke-width="9"
                           class="num-progress"></el-progress>
            </div>
            <div class="card-info">
              <label class="info-label">管理人</label>
              <span>{{item.personnelNames}}</span>
            </div>
            <div class="card-info">
              <label class="info-label">管理人部门</label>
              <span>{{item.departmentNames}}</span>
            </div>
            <div class="card-info">
              <label class="info-label">审核人</label>
              <span>{{item.reviewerNames}}</span>
            </div>
            <div class="card-info">
              <label class="info-label">巡检周期</label>
              <span>按月</span>
            </div>
          </div>
        </div>
      </div>
    </el-scrollbar>
    <div class="table-empty" v-else>
      <img src="@/common/assets/images/empty.svg" />
      <p>{{ $t("base.label.empty") }}</p>
    </div>
    <div class="ioc-table__pagination"
         v-if="page.total">
      <el-pagination class="mt10 mb10"
                     background
                     layout="total, sizes, prev, pager, next, jumper"
                     :page-size="page.pageSize"
                     :total="page.total"
                     :current-page="page.currentPage"
                     @size-change="sizeChange"
                     @current-change="pageChange"
                     @prev-click="pageChange"
                     @next-click="pageChange"/>
    </div>
  </div>
</template>

<script>
import utils from '@src/common/utils';
import { api } from '../api';

export default {
  name: 'building',
  data() {
    return {
      activeIndex: 1,
      tabBar: ['资产维度', '楼栋维度'],
      analysisTime: '',
      tableData: [],
      page: {
        currentPage: 1,
        total: 0,
        pageSize: utils.Cache.get('CURRENT_PAGESIZE') || 10
      },
    };
  },
  mounted() {
    this.analysisTime = utils.Dates.format(Date.now(), 'yyyy-MM');
    this.getList();
  },
  methods: {
    handleChooseActiveItem(index) {
      this.activeIndex = index;
      if (index === 0) {
        this.handleChooseItem()
      }
    },
    handleChooseItem(item) {
      if (item) {
        item.planCycle = 1;
      }
      this.$router.push({
        name: 'assetsRecord',
        params: item
      });
    },
    hasStatusColor(val) {
      switch (val) {
        case '1':
          return '#00A897';
        case '2':
          return '#409EFF';
        case '3':
          return '#E94E4E';
        default:
          return '#00A897';
      }
    },
    hasIndex(index) {
      let num = index + 1;
      if (num < 10) {
        return '0' + num;
      } else {
        return num;
      }
    },
    getList() {
      const params = {
        analysisTime: this.analysisTime,
        pageNum: this.page.currentPage,
        pageSize: this.page.pageSize
      };
      this.$fetch(api.assetsManage.queryFireAssetAnalysisByPage, params).then((response) => {
        if (!response.success) {
          this.$message.error(response.msgContent);
          return;
        }
        this.tableData = response.returnObj ? Object.freeze([...response.returnObj.list]) : [];
        this.page.total = response.returnObj ? response.returnObj.total : 0;
      });
    },
    sizeChange(val) {
      this.$store.dispatch('setCurrentPagesize', val);
      this.page.currentPage = 1;
      this.page.pageSize = val;
      this.getList();
    },
    pageChange(val) {
      this.page.currentPage = val;
      this.getList();
    },
  }
};
</script>
<style lang="scss">
  .num-progress {
    .el-progress-bar__outer {
      background: #456397;
    }

    .el-progress__text {
      color: #90A2C1;
    }
  }
</style>
<style lang="scss" scoped>
  .building-analysis {
    display: flex;
    flex-direction: column;
    padding-right: 20px;
    margin: 0;

    .building-search {
      display: flex;
      -webkit-box-pack: justify;
      -ms-flex-pack: justify;
      justify-content: space-between;
      position: relative;
      padding-bottom: 10px;
      overflow: hidden;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      border-bottom: 1px solid #3e5574;
      padding-top: 10px;
      margin: 0 10px;

      .tabBar {
        display: flex;

        .barItem {
          // color: white;
          cursor: pointer;
          font-size: 14px;
          font-family: Microsoft YaHei;
          margin: 9px 27px;

          &.active {
            color: #409EFF;
          }
        }
      }
    }
    .table-empty {
      display: flex;
      flex: 1;
      flex-direction: column;
      align-items: center;
      justify-content: center;
    }

    .card-list {
      flex: 1;
      display: flex;
      flex-wrap: wrap;

      .card {
        margin: 20px 0 0 20px;
        width: calc((100% - 80px)/4);
        height: 173px;
        background: #173C7D;
        display: flex;
        align-items: center;
        color: #90A2C1;
        cursor: pointer;

        .card-line {
          width: 4px;
          height: 100%;
          background: #00A897;
        }

        .card-index {
          margin: 0 40px;
          font-size: 50px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          line-height: 25px;
          color: #FFFFFF;
        }

        .card-contain {
          flex: 1;
          height: 100%;
          display: flex;
          flex-direction: column;
          justify-content: center;

          &-title {
            font-size: 16px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            line-height: 25px;
            color: #FFFFFF;
            margin-bottom: 15px;
          }

          &-num {
            display: flex;
            align-items: center;
            margin-bottom: 14px;

            .num-label {
              margin-right: 10px;
            }

            .num-percentage {
              margin-right: 7px;
            }

            .num-progress {
              width: 63%;
            }
          }
        }

        .card-info {
          display: flex;
          align-items: center;
          margin-bottom: 8px;

          .info-label {
            width: 70px;
            margin-right: 13px;
          }
        }
      }
    }
  }
</style>
